export default __webpack_public_path__ + "static/media/background.54e39825.svg";